import { defineStore } from 'pinia'
import api from '@/services/api'
import { useAuthStore } from './auth'


export const useUsuariosStore = defineStore('usuarios', {
  state: () => ({
    authStore: useAuthStore(),
    usuarios: []
  }),
  actions: {
    async get() {
        
        const result = await api.get('/usuarios', {
            headers: {
              Authorization: `Bearer ${this.authStore.access_token}`
            }
        })
        this.usuarios = result.data
    },
    async add(novoUsuario) {
        

      const result = await api.post('/usuarios', novoUsuario, {
            headers: {
              Authorization: `Bearer ${this.authStore.access_token}`
            }
        })
        
        if(result.data.id)
        {  
          return {status : true}
        }else{
          return {status : false, message : result.data.message}
        }

    },
    async update(usuario){

      const result = await api.put(`/usuarios/${usuario.id}`, usuario, {
            headers: {
              Authorization: `Bearer ${this.authStore.access_token}`
            }
        })
        
        if(result.data.id)
        {  
          return {status : true}
        }else{
          return {status : false, message : result.data.message}
        }

    },
    async delete(usuario){

      const result = await api.delete(`/usuarios/${usuario.id}`, {
            headers: {
              Authorization: `Bearer ${this.authStore.access_token}`
            }
        })
        
        if(result.data.id)
        {  
          return {status : true}
        }else{
          return {status : false, message : result.data.message}
        }

    } 
  }
})